/**
 * 跳转新的wn窗体
 * author:brian date 2022 06 21
 * */
/**
 *
 * @param {* 路由对象参数} param
 * @param {* 位置参数} postion
 * @param {* 是否为new win} isBliank
 * @param {* 回调对象参数} cbParam
 */

export function goNewWindows (param = {}, isBliank = true, postion = { top: 10, left: 10 }, cbParam) {
  const { href } = window.vm.$router.resolve(param)
  if (isBliank) {
    const clientHeight = document.documentElement.clientHeight
    const clientWidth = document.documentElement.clientWidth
    const openWindow = window.open(
      href,
      param.way || 'newwindow',
            `height=${clientHeight - 120},width=1200,top=${postion.top},left=${postion.left},toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no`
    )
    openWindow.onload = () => {
      openWindow.document.title = cbParam || ''
    }
    openWindow.focus()
  } else {
    window.open(href, '_blank')
  }
}
